export const ExpiredTokenPageConstants = {
  PageTitle: 'Oops, the link has expired...',
  PageParagraph: 'Links only last for 24 hours, please verify within this time.',
  ButtonLabel: 'Try again',
} as const
